import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import taskerAuth from "../../../services/taskerAuth";
import ProfileMenu from "./ProfileMenu";

type Props = {
  children: ReactNode;
};

function VendorPortalShell({ children }: Props) {
  const token = taskerAuth.getTaskerToken();
  const showProfileMenu = Boolean(token);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#F5F7FC" }}>
      <Box
        component="header"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 4,
          py: 2,
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              bgcolor: "primary.main",
              color: "primary.contrastText",
              borderRadius: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              fontSize: 18,
            }}
          >
            V
          </Box>
          <Typography
            component="span"
            sx={{ fontSize: 17, fontWeight: 700 }}
          >
            Vendor Portal
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Livspace Vendor Onboarding
          </Typography>
          {showProfileMenu && <ProfileMenu />}
        </Box>
      </Box>
      <Box component="main">{children}</Box>
    </Box>
  );
}

export default VendorPortalShell;
